import { CardWrapper } from '@ami/react/core';
import { FormDefaultActions as Actions } from '@ami/react/core';
import PropTypes from 'prop-types';
import React from 'react';
import { Form } from 'reactstrap';
import DealerUserEditFormData from './DealerUserEditFormData';
import { makeValidable } from '@ami/react/core';
import { monitorChangesOn } from '@ami/react/core';

const ValidableDealerUserEditFormData = makeValidable(DealerUserEditFormData);

class DealerUserEditForm extends React.Component {
  constructor(props) {
    super(props);
    this.validableRef = React.createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      showValidations: false,
    };
  }

  static defaultProps = {
    enabledAddDealerGroup: true,
    enabledRemoveDealerGroup: true,
  };

  static propTypes = {
    dealerUser: PropTypes.object.isRequired,
    permissions: PropTypes.object.isRequired,
    availableEmailTemplateTypes: PropTypes.array.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    deleteEnabled: PropTypes.bool.isRequired,
    dealerUserChanged: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    openChangePasswordModal: PropTypes.func.isRequired,
    sendingInvitation: PropTypes.bool.isRequired,
    sendInvitationEmail: PropTypes.func.isRequired,
    enabledAddDealerGroup: PropTypes.bool,
    enabledRemoveDealerGroup: PropTypes.bool,
  };

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ showValidations: true }, () => {
      if (this.validableRef.current.isValid()) {
        this.props.onSubmit();
      }
    });
  }

  render() {
    var {
      dealerUser,
      permissions,
      dealerUserChanged,
      availableEmailTemplateTypes,
      openChangePasswordModal,
      sendingInvitation,
      sendInvitationEmail,
      onCancel,
      onDelete,
      deleteEnabled,
      submitting,
      enabledAddDealerGroup,
      enabledRemoveDealerGroup,
    } = this.props;
    return (
      <CardWrapper title="Edit Dealer User">
        <Form>
          <ValidableDealerUserEditFormData
            ref={this.validableRef}
            showValidations={this.state.showValidations}
            dealerUser={dealerUser}
            permissions={permissions}
            dealerUserChanged={dealerUserChanged}
            availableEmailTemplateTypes={availableEmailTemplateTypes}
            openChangePasswordModal={openChangePasswordModal}
            sendingInvitation={sendingInvitation}
            sendInvitationEmail={sendInvitationEmail}
            enabledAddDealerGroup={enabledAddDealerGroup}
            enabledRemoveDealerGroup={enabledRemoveDealerGroup}
          />
          <Actions
            onSubmit={this.handleSubmit}
            onCancel={onCancel}
            onDelete={onDelete}
            deleteEnabled={deleteEnabled}
            deleteOptions={{
              entityName: 'Dealer User',
              instanceName: dealerUser.fullName,
            }}
            submitting={submitting}
          />
        </Form>
      </CardWrapper>
    );
  }
}

export default monitorChangesOn(DealerUserEditForm);
